export interface Stat {
    label: string;
    value: string;
}

interface StatsCardProps {
    stat: Stat;
    className?: string;
}

export default function StatsCard({ stat, className = '' }: StatsCardProps) {
    return (
        <div className={`rounded-xl border border-[#E0E0E0] bg-[#F5F5F5] px-6 py-4 text-center ${className}`}>
            <p className="truncate text-[13px] text-[#333333]">{stat.label}</p>
            <p className="mt-0.5 text-xl font-bold text-secondary">{stat.value}</p>
        </div>
    );
}
